import React from "react";

import { getString, isLoggedInWithoutRole } from "../../utilities";
import { breakpoints, language, userRoles } from "../../config/constants";
import { getLangCode } from "../../config";

// en art
import en360webp from "../../../assets/img/homeWelcome360.webp";
import en360png from "../../../assets/img/homeWelcome360.png";
import en360X2webp from "../../../assets/img/homeWelcome360@2x.webp";
import en360X2png from "../../../assets/img/homeWelcome360@2x.png";

import en640webp from "../../../assets/img/homeWelcome640.webp";
import en640png from "../../../assets/img/homeWelcome640.png";
import en640X2webp from "../../../assets/img/homeWelcome640@2x.webp";
import en640X2png from "../../../assets/img/homeWelcome640@2x.png";

import en768webp from "../../../assets/img/homeWelcome768.webp";
import en768png from "../../../assets/img/homeWelcome768.png";
import en768X2webp from "../../../assets/img/homeWelcome768@2x.webp";
import en768X2png from "../../../assets/img/homeWelcome768@2x.png";

import en1024webp from "../../../assets/img/homeWelcome1024.webp";
import en1024png from "../../../assets/img/homeWelcome1024.png";
import en1024X2webp from "../../../assets/img/homeWelcome1024@2x.webp";
import en1024X2png from "../../../assets/img/homeWelcome1024@2x.png";

// la art
import la360webp from "../../../assets/img/homeWelcome360_la.webp";
import la360png from "../../../assets/img/homeWelcome360_la.png";
import la360X2webp from "../../../assets/img/homeWelcome360_la@2x.webp";
import la360X2png from "../../../assets/img/homeWelcome360_la@2x.png";

import la640webp from "../../../assets/img/homeWelcome640_la.webp";
import la640png from "../../../assets/img/homeWelcome640_la.png";
import la640X2webp from "../../../assets/img/homeWelcome640_la@2x.webp";
import la640X2png from "../../../assets/img/homeWelcome640_la@2x.png";

import la768webp from "../../../assets/img/homeWelcome768_la.webp";
import la768png from "../../../assets/img/homeWelcome768_la.png";
import la768X2webp from "../../../assets/img/homeWelcome768_la@2x.webp";
import la768X2png from "../../../assets/img/homeWelcome768_la@2x.png";

import la1024webp from "../../../assets/img/homeWelcome1024_la.webp";
import la1024png from "../../../assets/img/homeWelcome1024_la.png";
import la1024X2webp from "../../../assets/img/homeWelcome1024_la@2x.webp";
import la1024X2png from "../../../assets/img/homeWelcome1024_la@2x.png";

export default function Welcome() {
  if (!isLoggedInWithoutRole(userRoles.free)) {
    const langCode = getLangCode();

    const welcomeArt = {
      [language.default]: {
        xs: {
          webp: [en360webp, en360X2webp],
          png: [en360png, en360X2png],
        },
        sm: {
          webp: [en640webp, en640X2webp],
          png: [en640png, en640X2png],
        },
        md: {
          webp: [en768webp, en768X2webp],
          png: [en768png, en768X2png],
        },
        lg: {
          webp: [en1024webp, en1024X2webp],
          png: [en1024png, en1024X2png],
        },
      },
      [language.la]: {
        xs: {
          webp: [la360webp, la360X2webp],
          png: [la360png, la360X2png],
        },
        sm: {
          webp: [la640webp, la640X2webp],
          png: [la640png, la640X2png],
        },
        md: {
          webp: [la768webp, la768X2webp],
          png: [la768png, la768X2png],
        },
        lg: {
          webp: [la1024webp, la1024X2webp],
          png: [la1024png, la1024X2png],
        },
      },
    };

    const renderSources = () => {
      const langObject = welcomeArt[langCode] || welcomeArt[language.default];
      const sizeArray = Object.keys(langObject);

      return sizeArray.reduce((sourceArray, widthSize, index) => {
        const sizeObject = langObject[widthSize];
        const media = index === sizeArray.length - 1 ? "" : `(max-width: ${breakpoints.width[widthSize]}px)`;

        const nextSource = Object.keys(sizeObject).map((type) => {
          const typeArray = sizeObject[type];
          return (
            <source
              key={typeArray[0]}
              type={`image/${type}`}
              srcSet={`${typeArray[0]} 1x, ${typeArray[1]} 2x`}
              media={media}
            />
          );
        });
        return [...sourceArray, ...nextSource];
      }, []);
    };

    let imgSrc = en1024png;
    let imgSrcSet = `${en1024png} 1x, ${en1024X2png} 2x`;

    if (langCode === language.la) {
      imgSrc = la1024png;
      imgSrcSet = `${la1024png} 1x, ${la1024X2png} 2x`;
    }

    return (
      <div className="home-welcome">
        <div className="home-welcome-container">
          <picture>
            {renderSources()}

            <img
              data-testid="home-welcome"
              src={imgSrc}
              srcSet={imgSrcSet}
              alt={getString("abcya.0")}
              width="1247"
              height="390"
              draggable="false"
              fetchPriority="high"
            />
          </picture>
        </div>
      </div>
    );
  }

  return null;
}
